import { client, gql } from 'data-provider';
import { IMeasurementUnit } from 'interfaces';

export const getMeasurementUnits = async (queryParam?: {
  searchString?: string;
  start?: number;
  limit?: number;
}) => {
  const where = { query: '' };
  if (queryParam?.searchString) {
    where.query = queryParam.searchString;
  }

  const query = gql`
    query ($where: JSON, $sort: SortInput, $start: Int, $limit: Int) {
      measurementUnits(where: $where, sort: $sort, start: $start, limit: $limit) {
        data {
          id
          name
          abbreviation
          description
        }
        page
        size
        total
      }
    }
  `;

  const variables = {
    where,
    start: queryParam && queryParam.start ? queryParam.start : 1,
    limit: queryParam && queryParam.limit ? queryParam.limit : 10,
  };
  const data = await client.request(query, variables);
  return data.measurementUnits as {
    data: IMeasurementUnit[];
    page: number;
    size: number;
    total: number;
  };
};

export const getMeasurementUnitsDropdown = async () => {
  const mutation = gql`
    query {
      measurementUnitDropdown {
        id
        name
        abbreviation
      }
    }
  `;

  const data = await client.request(mutation);
  return data.measurementUnitDropdown as {
    id: string;
    name: string;
    abbreviation: string;
  }[];
};

export const createMeasurementUnit = async (data: IMeasurementUnit) => {
  const mutation = gql`
    mutation CreateMeasurementUnit($input: createMeasurementUnitInput) {
      createMeasurementUnit(input: $input) {
        id
        name
        abbreviation
        description
      }
    }
  `;

  const variables = {
    input: { data },
  };

  const createdData = await client.request(mutation, variables);
  return createdData;
};

export const getMeasurementUnit = async (id: string) => {
  const query = gql`
    query ($measurementUnitId: ID!) {
      measurementUnit(id: $measurementUnitId) {
        id
        name
        abbreviation
        description
      }
    }
  `;

  const variables = { measurementUnitId: id };
  const data = await client.request(query, variables);
  return data.measurementUnit as IMeasurementUnit;
};

export const updateMeasurementUnit = async (id: string, data: Omit<IMeasurementUnit, 'id'>) => {
  const mutation = gql`
    mutation ($input: updateMeasurementUnitInput) {
      updateMeasurementUnit(input: $input) {
        id
        name
        abbreviation
        description
      }
    }
  `;

  const variables = {
    input: {
      where: { id },
      data,
    },
  };
  const updatedData = await client.request(mutation, variables);
  return updatedData.updateMeasurementUnit as IMeasurementUnit;
};

export const deleteMeasurementUnit = async (id: string) => {
  const mutation = gql`
    mutation ($input: deleteMeasurementUnitInput) {
      deleteMeasurementUnit(input: $input) {
        measurementUnit {
          id
        }
      }
    }
  `;

  const variables = {
    input: {
      where: { id },
    },
  };

  await client.request(mutation, variables);
};
